import { G as GraphGradientMode } from '../../../../../index-DuYVZf5J.js';

"use strict";
const pluginVersion = "13.0.0-pre";
const defaultOptions = {
  bucketCount: 30,
  bucketOffset: 0
};
const defaultFieldConfig = {
  fillOpacity: 80,
  gradientMode: GraphGradientMode.None,
  lineWidth: 1
};

export { defaultFieldConfig, defaultOptions, pluginVersion };
